"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var MBCard = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return jsx_runtime_1.jsx(StyledCard, __assign({}, rest, { children: children }), void 0);
};
exports.MBCard = MBCard;
var StyledCard = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 4px;\n  border-radius: 4px;\n  background: #fff;\n  border: 1px solid #000;\n  box-shadow: 5px 5px 0px 0 rgba(0, 0, 0, 0.2);\n  min-width: ", ";\n"], ["\n  padding: 4px;\n  border-radius: 4px;\n  background: #fff;\n  border: 1px solid #000;\n  box-shadow: 5px 5px 0px 0 rgba(0, 0, 0, 0.2);\n  min-width: ", ";\n"])), function (_a) {
    var minWidth = _a.minWidth;
    return minWidth && minWidth + "px";
});
var templateObject_1;
//# sourceMappingURL=MBCard.js.map